import * as React from 'react';

export const Logout = () => (
  <svg
    className='logout-icon'
    width='23px'
    height='23px'
    viewBox='0 0 23 23'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <defs>
      <polygon
        id='path-1'
        points='15.2436354 0.291354894 15.2436354 22.3146996 0.342102357 22.3146996 0.342102357 0.291354894'
      ></polygon>
      <polygon id='path-3' points='0 8.63499064 0 0.400309787 15.5420267 0.400309787 15.5420267 8.63499064'></polygon>
    </defs>
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='Nightgraph-Overview' transform='translate(-23.000000, -759.000000)'>
        <g id='Page-1' transform='translate(23.000000, 759.000000)'>
          <g id='Group-3' transform='translate(7.328671, 0.194043)'>
            <mask id='mask-2' fill='white'>
              <use xlinkHref='#path-1'></use>
            </mask>
            <g id='Clip-2'></g>
            <path
              className='navigation-icon-fill'
              d='M13.2894209,22.3146996 L2.24755679,22.3146996 C1.22154286,22.3146996 0.342102357,21.4905038 0.342102357,20.4232698 L0.342102357,14.8445464 C0.342102357,14.5044868 0.635249193,14.2619336 0.928396028,14.2619336 C1.27040067,14.2619336 1.5146897,14.5529974 1.5146897,14.8445464 L1.5146897,20.4232698 C1.5146897,20.8108698 1.80783653,21.1019336 2.19869898,21.1019336 L13.2400745,21.1019336 C13.6314256,21.1019336 13.9245724,20.8108698 13.9245724,20.4232698 L13.9245724,2.18278468 C13.9245724,1.79469957 13.6314256,1.50412085 13.2400745,1.50412085 L2.24755679,1.50412085 C1.85669434,1.50412085 1.5635475,1.79469957 1.5635475,2.18278468 L1.5635475,8.00406128 C1.5635475,8.34363574 1.27040067,8.58618894 0.977253834,8.58618894 C0.635249193,8.58618894 0.390960163,8.29561021 0.390960163,8.00406128 L0.390960163,2.18278468 C0.390960163,1.16406128 1.22154286,0.291354894 2.29641459,0.291354894 L13.3382787,0.291354894 C14.3642927,0.291354894 15.2437332,1.11555064 15.2437332,2.18278468 L15.2437332,20.4232698 C15.1943868,21.4415081 14.3154348,22.3146996 13.2894209,22.3146996'
              id='Fill-1'
              mask='url(#mask-2)'
            ></path>
          </g>
          <g id='Group-6' transform='translate(0.000000, 6.985532)'>
            <mask id='mask-4' fill='white'>
              <use xlinkHref='#path-3'></use>
            </mask>
            <g id='Clip-5'></g>
            <path
              className='navigation-icon-fill'
              d='M14.9502932,3.92945872 L2.00297461,3.92945872 L4.49521129,1.45541617 C4.73950032,1.21286298 4.73950032,0.824777872 4.49521129,0.582224681 C4.25092226,0.339671489 3.85957124,0.339671489 3.61528221,0.582224681 L0.244093598,3.92945872 C0.0980087587,4.07499064 -0.000195431224,4.26903319 -0.000195431224,4.51158638 C-0.000195431224,4.75413957 0.0980087587,4.94818213 0.244093598,5.09322894 L3.61528221,8.44094809 C3.71299782,8.53796936 3.90842904,8.63499064 4.05500246,8.63499064 C4.20157588,8.63499064 4.3481493,8.58648 4.49521129,8.44094809 C4.73950032,8.19839489 4.73950032,7.81030979 4.49521129,7.5677566 L2.00297461,5.09322894 L14.9502932,5.09322894 C15.2922978,5.09322894 15.5365869,4.80265021 15.5365869,4.51158638 C15.5859332,4.17201191 15.2922978,3.92945872 14.9502932,3.92945872'
              id='Fill-4'
              mask='url(#mask-4)'
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
